const passengers = {
  table: {
    headers: {
      name: 'Nome',
      email: 'E-mail',
      created: 'Data de criação',
      id: 'Identificação',
      profiles: 'Perfis em Anexo',
      createdBy: 'Criado por',
      baseAddress: 'Endereço de casa',
      occupationAddress: 'Endereço do trabalho',
      createdAt: 'Criado em',
      profile: 'Perfil',
    },
  },
};

export default passengers;
